<script setup lang="ts">
const { isDark, toggle } = useDarkMode()
</script>

<template>
  <button
    type="button"
    class="flex items-center justify-center h-10 w-10 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
    @click="toggle"
    :aria-label="isDark ? 'Switch to light mode' : 'Switch to dark mode'"
  >
    <ClientOnly fallback-tag="span">
      <UIcon
        :name="isDark ? 'i-lucide-sun' : 'i-lucide-moon'"
        class="w-5 h-5 text-gray-700 dark:text-gray-300"
      />
      <template #fallback>
        <span class="w-5 h-5 block" />
      </template>
    </ClientOnly>
  </button>
</template>
